import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MiatAssignedRisk } from '../models/miat-assigned-risk.model';

@Injectable({
  providedIn: 'root'
})
export class MiatService {

  constructor(
    private http: HttpClient,
    @Inject('environment') private environment: any
  ) { }

  /**
   * Get recommended risks based on observation and recommendation text
   * This method calls a lambda function on AWS that works like a blackbox
   * @param textHechoObs Observation fact text
   * @param textoDesrecom Recommendation description text
   * @returns Observable with recommended risks
   */
  getRecommendedRisks(textHechoObs: string, textoDesrecom: string): Observable<any> {
    const payload = {
      texto_hecho_obs: textHechoObs,
      texto_desrecom: textoDesrecom
    };

    return this.http.post(
      `${this.environment.base_URL}/risk-assign`,
      payload
    );
  }

  /**
   * Save recommended risks to DB
   * @param miatAssignedRisks Miat Observer Risk Business Objects
   * @returns Observable with save result
   */
  saveRecommendedRisks(miatAssignedRisks: MiatAssignedRisk[]): Observable<any> {
    return this.http.post(
      `${this.environment.base_URL_GAIA}/miat/recommendation`,
      miatAssignedRisks
    );
  }
}
